import { authService, PermissionScope } from "@/services/AuthService";

interface PermissionGuardProps {
    resource: string | readonly string[];
    scope: PermissionScope | readonly PermissionScope[];
    fallback?: React.ReactNode;
    children: React.ReactNode;
  }
  
  const PermissionGuard: React.FC<PermissionGuardProps> = ({ 
    resource, 
    scope, 
    fallback = null, 
    children 
  }) => {
    const authorization = authService.parsedToken?.authorization;
  
    if (!authorization) return <>{fallback}</>;
  
    const resources = Array.isArray(resource) ? resource : [resource];
    const scopes = Array.isArray(scope) ? scope : [scope];
  
    const hasAccess = resources.some(res => 
        scopes.some(s => authorization?.hasPermission(res, s))
    );
  
    return hasAccess ? <>{children}</> : <>{fallback}</>;
  };
  
  export default PermissionGuard;